import React from 'react';
import FieldBox from '../../../../uikit/fields/FieldBox';
import { SingleCheckbox, } from '../../../atoms/SingleCheckbox';
import { withFormikField } from '../../../../hoc/withFormikField';
export function CheckboxField(props) {
    var name = props.name, label = props.label, value = props.value, errors = props.errors, onChange = props.onChange;
    var error = !!errors && errors.length ? errors[0] : undefined;
    return (React.createElement(FieldBox, { name: name, error: error },
        React.createElement(SingleCheckbox, { name: name, label: label, value: value, onChange: onChange, error: !!error })));
}
export var CheckboxFormikField = withFormikField(CheckboxField);
